import Vue from 'vue';
import Vuex from 'vuex';
import { getNextStep, getInitialState } from './utils/decisionTree';

Vue.use(Vuex);

export default new Vuex.Store({
  state: getInitialState(),
  mutations: {
    setModalOpen(state, value) { state.isOpen = value; },
    setCurrentStep(state, step) { state.currentStep = step; },
    setAnswer(state, { key, value }) { Vue.set(state.answers, key, value); },
    setPostcodeResult(state, value) { Vue.set(state.answers, 'postcodeResult', value); },
    setSchoolResult(state, value) { Vue.set(state.answers, 'schoolResult', value); },
    pushHistory(state, step) { state.history.push(step); },
    popHistory(state) { state.history.pop(); },
    setOutcome(state, outcome) { state.outcome = outcome; },
    reset(state) { Object.assign(state, getInitialState()); }
  },
  actions: {
    start({ commit }) {
      commit('reset');
      commit('setModalOpen', true);
      commit('setCurrentStep', 'Q1');
    },
    answer({ state, commit }, payload) {
      commit('setAnswer', payload);
      const nextStep = getNextStep(state.currentStep, { ...state.answers, [payload.key]: payload.value });
      commit('pushHistory', state.currentStep);
      if (nextStep && nextStep.startsWith('O')) {
        commit('setOutcome', nextStep);
        commit('setCurrentStep', nextStep);
      } else {
        commit('setCurrentStep', nextStep);
      }
    },
    continueFromLookup({ state, commit }, payload) {
      if (payload.key === 'postcode') commit('setPostcodeResult', payload.result);
      if (payload.key === 'school') commit('setSchoolResult', payload.result);
      const answers = { ...state.answers };
      if (payload.key === 'postcode') answers.postcodeResult = payload.result;
      if (payload.key === 'school') answers.schoolResult = payload.result;
      const nextStep = getNextStep(state.currentStep, answers);
      commit('pushHistory', state.currentStep);
      if (nextStep && nextStep.startsWith('O')) {
        commit('setOutcome', nextStep);
        commit('setCurrentStep', nextStep);
      } else {
        commit('setCurrentStep', nextStep);
      }
    },
    back({ state, commit }) {
      const previous = state.history[state.history.length - 1];
      if (!previous) {
        commit('setCurrentStep', 'T1');
        return;
      }
      commit('setOutcome', null);
      commit('setCurrentStep', previous);
      commit('popHistory');
    }
  }
});
